export function track(eventId: string, eventType: string, metadata?: Record<string, string>) {
  const csrfToken = document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content

  fetch('/t', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': csrfToken || '',
    },
    body: JSON.stringify({ event_id: eventId, event_type: eventType, metadata }),
    keepalive: true,
  }).catch(() => {})
}
